"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanelMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
/** @class TabPanelMixin */
/** @method */
var TabPanelMixin = function TabPanelMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'Tabs.backgroundColor',
    padding: 'Tabs.Panel.padding'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      padding = _ref.padding;
    return (0, _styledComponents.css)(["background-color:", ";padding:", ";", ""], backgroundColor, padding ? padding + "px" : (0, _spaceMixin.spaceMixin)('sm')(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.TabPanelMixin = TabPanelMixin;